angular.module('impactx.rfx').controller('RFXBuyerCtrl', [
    '$scope',
    '$routeParams',
    'RFXBuyerService',
    'ProductSelectionService',
    'AutocompleteSelectionPanel',
    'DownloadService',
    '$timeout',
    'ToastService',
    '$mdPanel',
    '$mdDialog',
    'AppConfiguration',
    'ToolbarService',
    '$redirect',
    'BackService',
    'TranslationService',
    'RedirectAndSaveService',
    'ConfirmationService',
    '$route',
    'dataGen',
    'RFQSearchService',
    '$location',
    '$sce',
    'ixaRFXBuyerService',
    RFXBuyerController
]);

function RFXBuyerController($scope, $routeParams, RFXBuyerService, ProductSelectionService, AutocompleteSelectionPanel,
                            DownloadService, $timeout, ToastService, $mdPanel, $mdDialog, AppConfiguration, ToolbarService,
                            $redirect, BackService, TranslationService, RedirectAndSaveService, ConfirmationService, $route,
                            dataGen, RFQSearchService, $location, $sce, ixaRFXBuyerService) {
    var self = this;
    self.$sce = $sce;
    self.id = $routeParams.rfqhId || 0;
    self.rfqcId = $routeParams.rfqcId || 0;
    self.preselectSupplierId = $routeParams.supplierId || 0;
    self.tenderId = $routeParams.tenderId || 0;
    self.lotId = $routeParams.lotId || 0;
    self.selectedPositions = [];
    self.previousDeleted = [];
    self.positionDialIsOpen = false;
    self.supplierSelectionIsOpen = false;
    self.requestInProgress = false;
    self.publicationMinDate = new Date();
    self.weightingTotal = 0;
    self.changedWeight = false;
    self.lastAnswerDateTimeMinDate = new Date(self.publicationMinDate);
    self.sendErrorList = [];

    function getData() {
        var data = RFQSearchService.getDialogData();

        if ($routeParams.productIdToAdd < 0 && data && data.data) {
            self.data = data.data;
            self.trns = data.trns;
            defineButtons();
        }
        else if ($routeParams.productIdToAdd > 0 && data && data.data) {
            self.data = data.data;
            self.trns = data.trns;
            RFXBuyerService.getItemData(self.id, self.rfqsId, $routeParams.productIdToAdd, 0, false, decodeURIComponent($routeParams.amountToAdd)).then(function (item) {
                self.pushItem(item);
                defineButtons();
            }, defineButtons);
        }
        else {
            return RFXBuyerService.getDialogData(self).then(function () {
                self.trns.required = TranslationService.get("required");
                defineButtons();
                adjustDates();
                $timeout(function () {
                    self.checkWeights(false, self.data.items);
                })
            });
        }
    }

    self.saveData = function () {
        return RFXBuyerService.saveDialogData(self, false);
    };

    self.saveDataAndBack = function () {
        return RFXBuyerService.saveDialogData(self, true);
    };

    self.sendData = function (event) {
        if (self.data.useTextCustomization) {
            var tempScope = {};
            RFXBuyerService.saveData(tempScope, self).then(function () {
                var rfghId = self.id > 0 ? self.id : tempScope.data.rfqhId;
                self.data.id = rfghId;
                RFXBuyerService.showTextCustomization(event, rfghId, RFXBuyerService.STATUS.READY_FOR_PUBLISH).then(function (result) {
                    if (result && result.send) {
                        RFXBuyerService.sendAfterTextCustomization(self);
                    }
                    else {
                        $route.reload();
                    }
                }, function () {
                    $route.reload();
                });
            });
        }
        else {
            RFXBuyerService.sendDialogData(self);
        }
    };

    self.saveDates = function () {
        return RFXBuyerService.saveDates(self);
    };

    self.saveUsers = function () {
        RFXBuyerService.saveUsers(self);
    };

    self.decide = function () {
        $redirect.redirectTo(null, '/rfxbuyerdecide/' + self.id);
    };

    function getRfqsForNewRound(supplierEntries) {
        var result = [];
        angular.forEach(supplierEntries, function (entry) {
            if (entry.selected) {
                result.push(entry.rfqsId);
            }
        });
        return result;
    }

    self.newRound = function (event) {
        RFXBuyerService.showNewRoundDialog(event, self.id).then(function (newRoundResult) {
            var selectedRFQS = getRfqsForNewRound(newRoundResult.suppliers);
            if (selectedRFQS && selectedRFQS.length > 0) {
                if (self.data.useTextCustomization) {
                    RFXBuyerService.showTextCustomization(event, self.id, RFXBuyerService.STATUS.NEW_ROUND, selectedRFQS).then(function (result) {
                        if (result && result.send) {
                            RFXBuyerService.saveNewRound(event, newRoundResult);
                        }
                        else {
                            $route.reload();
                        }
                    }, function () {
                        $route.reload();
                    });
                }
                else {
                    RFXBuyerService.saveNewRound(event, newRoundResult);
                }
            }
        });
    }

    self.back = function () {
        $redirect.redirectTo(null, '/rfxbuyerlist');
    };

    function cancelInternal(event, rework) {
        RFXBuyerService.showCancelDialog(event, self.id, self.trns, rework).then(function () {
            self.back();
        });
    }

    self.reworkBeforeSend = function (event) {
        RFXBuyerService.showReworkBeforeSend(event, self.id, self.trns.reworkBeforeSend, self.trns.reworkBeforeSendText);
    };

    self.cancel = function (event) {
        if (self.data.useTextCustomization) {
            RFXBuyerService.showTextCustomization(event, self.id, RFXBuyerService.STATUS.CANCELLED).then(function () {
                cancelInternal(event, false);
            });
        }
        else {
            cancelInternal(event, false);
        }
    };

    self.rework = function (event) {
        if (self.data.useTextCustomization) {
            RFXBuyerService.showTextCustomization(event, self.id, RFXBuyerService.STATUS.REWORK).then(function () {
                cancelInternal(event, true);
            });
        }
        else {
            cancelInternal(event, true);
        }
    };

    self.downloadAttachment = function (media) {
        DownloadService.openDownloadPost('/rfx/download/media', {paramName: "id", paramValue: media.id});
    };

    $scope.$watch('rfxBuyerCtrl.positionDialIsOpen', function (positionDialIsOpen) {
        if (positionDialIsOpen) {
            $timeout(function () {
                self.tooltipVisible = self.positionDialIsOpen;
            }, 500);
        }
        else {
            self.tooltipVisible = self.positionDialIsOpen;
        }
    });

    $scope.setLastAnswerDateTimeMinDate = function (publicationDate) {
        self.lastAnswerDateTimeMinDate = new Date(publicationDate.dateValue === null || isNaN(publicationDate.dateValue)? self.publicationMinDate : publicationDate.dateValue);
        self.lastAnswerDateTimeMinDate.setDate(self.lastAnswerDateTimeMinDate.getDate() + self.data.lastAnswerMinDays);
    };

    function adjustDates() {
        $scope.setLastAnswerDateTimeMinDate(self.data.publicationDate);
    }

    self.canAddProduct = function () {
        return impactX.isDefined(self, 'data.allowAddProductBuyer');
    };
    
    self.openProductSelection = function (event) {
        var params = {id: $routeParams.rfqhId};
        params.data = self.data;
        params.trns = self.trns;
        params.path = $location.path();
        params.rfqcId = self.data.rfqcId;
        params.supplierId = self.preselectSupplierId
        params.tenderId = self.tenderId;
        params.lotId = self.lotId;
        if ($routeParams.amountToAdd) {
            params.path = params.path.substring(0, params.path.lastIndexOf("/"));
        }
        if ($routeParams.productIdToAdd) {
            params.path = params.path.substring(0, params.path.lastIndexOf("/"));
        }
        if (!$routeParams.rfqcId) {
            params.path = params.path + "/0";
        }
        if (!$routeParams.supplierId) {
            params.path = params.path + "/0";
        }
        if (!$routeParams.tenderId) {
            params.path = params.path + "/0";
        }
        if (!$routeParams.lotId) {
            params.path = params.path + "/0";
        }
        RFQSearchService.activateRFQHSearch(params);
    };

    self.canAddQuestion = function () {
        return impactX.isDefined(self, 'data.allowAddQuestionBuyer');
    };

    self.canAddInternal = function () {
        return impactX.isDefined(self, 'data.allowAddInternalBuyer');
    };

    self.canAddSmartform = function () {
        return impactX.isDefined(self, 'data.allowAddSmartformBuyer');
    };

    self.addQuestion = function (event) {
        var newItem = {isInformation: true};
        RFXBuyerService.showEditPositionDialog(event, self.id, newItem, self.trns).then(function (item) {
            self.pushItem(item);
        })
    };

    self.addInternal = function (event) {
        var newItem = {isInternal: true};
        RFXBuyerService.showEditPositionDialog(event, self.id, newItem, self.trns).then(function (item) {
            self.pushItem(item);
        })
    };

    self.canAddFreeFormItem = function () {
        return impactX.isDefined(self, 'data.allowAddFreeformBuyer');
    };

    self.addFreeformItem = function (event) {
        RFXBuyerService.showEditPositionDialog(event, self.id, {isFreeForm: true}, self.trns).then(function (item) {
            self.pushItem(item);
        })
    };

    self.addSmartFormItem = function (event) {
        RFXBuyerService.openSmartFormItemDialog(event, self.data.smartFormTemplates, self.id, {}, self.trns).then(function (item) {
            item.isInformation = self.isInformation(item);
            self.pushItem(item);
        })
    };

    self.isInformation = function (item) {
        var policy;
        if (item.smartForm) {
            policy = self.getSmartFormPolicy(item.smartForm.identifier);
        }
        return item.isInformation || (policy && policy.isInformation);
    };

    self.pushItem = function (item) {
        $scope.dialogData.$setDirty();
        self.data.items.push(item);
        if (!self.changedWeight) {
            self.normalizeWeights();
        }
    };

    self.getSmartFormPolicy = function (id) {
        var policies = self.data.smartFormPolicies;
        if (typeof id === 'string') {
            for (var key in policies) {
                if (policies.hasOwnProperty(key) &&
                    policies[key].identifier === id) {
                    return policies[key];
                }
            }
        }
        else if (typeof id === 'number' && !isNaN(id)) {
            return policies[id];
        }
    };

    self.selectPosition = function (position) {
        var index = self.selectedPositions.indexOf(position);
        if (index < 0) {
            self.selectedPositions.push(position);
        }
        else {
            self.selectedPositions.splice(index, 1);
        }
    };

    self.isSelected = function (item) {
        return self.selectedPositions.indexOf(item) >= 0;
    };

    self.editPosition = function (event) {
        if (self.selectedPositions.length == 1) {
            $scope.dialogData.$setDirty();
            var selectedItem = self.selectedPositions[0];
            RFXBuyerService.showEditPositionDialog(event, self.id, selectedItem, self.trns, self.data.smartFormTemplates).then(function (item) {
                item.isInformation = self.isInformation(item);
                var index = self.data.items.indexOf(selectedItem);
                if (index >= 0) {
                    self.data.items[index] = item;
                }
            });

            self.selectedPositions = [];
        }
    };

    self.deletePositions = function () {
        $scope.dialogData.$setDirty();
        self.previousDeleted = [];
        angular.forEach(self.selectedPositions, function (entry) {
            var index = self.data.items.indexOf(entry);
            if (index >= 0) {
                self.previousDeleted.push(entry);
                self.data.items.splice(index, 1);
            }
        });
        self.selectedPositions = [];

        RFXBuyerService.showRevertDeletionToast(revertDeletion);
    };

    self.canDeleteSupplier = function (supplier)
    {
        return !self.data.readOnlyDialog && !supplier.readOnly;
    };

    self.deleteSupplierDialog = function (event, supplier) {
        if (self.data.showSupplierDeleteConfirmationDialog) {
            const question = self.trns.deleteSupplierQuestion.replace('^0', supplier.value)
            ConfirmationService.showConfirmationDialog(function () {
                return self.deleteSupplier(supplier);
            },
            event, TranslationService.get('confirmDelete'),
            TranslationService.get('delete'), TranslationService.get('abort'), question);
        }
        else {
            self.deleteSupplier(supplier);
        }
    };

    self.deleteSupplier = function (supplier) {
        var index = self.data.suppliers.indexOf(supplier);
        if (index >= 0) {
            self.data.suppliers.splice(index, 1);
        }
        $scope.dialogData.$setDirty();
    };

    self.openSupplierSelection = function (event) {
        var config = {
            uri: "/rfx/buyer/supplier",
            parameters: {
                rfqcId: self.data.rfqcId
            },
            selected: self.data.suppliers,
            event: event,
            xPosition: $mdPanel.xPosition.ALIGN_END,
            yPosition: $mdPanel.yPosition.BELOW
        };
        self.supplierSelectionIsOpen = true;
        AutocompleteSelectionPanel.openPanel(config).then(function (selection) {
            $scope.dialogData.$setDirty();
            self.data.suppliers.push(selection);

        }, angular.noop).finally(function () {
            self.supplierSelectionIsOpen = false;
        });
    };

    self.openAddSupplierListDialog = function (event, afterSend) {
        $mdDialog.show({
            templateUrl: "modules/rfx/templates/rfx-add-supplier-list-dialog.html",
            controller: "RFXAddSupplierListCtrl",
            controllerAs: "ctrl",
            targetEvent: event,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
                config: {
                    rfqhId: self.id,
                    rfqcId: self.data.rfqcId,
                    selected: self.data.suppliers,
                    afterSend: afterSend,
                    tenderId: self.tenderId,
                    lotId: self.lotId
                }
            }
        }).then(function (selection) {
            if(selection)
            {
                $scope.dialogData.$setDirty();
                self.data.suppliers.push(...selection)
            }
        }, angular.noop);
    };

    self.openCreateNewSupplierDialog = function () {
        var tempScope = {};
        RFXBuyerService.saveData(tempScope, self).then(function () {
            var rfghId = self.id > 0 ? self.id : tempScope.data.rfqhId;
            ixaRFXBuyerService.openCreateNewSupplierPopupDialog(rfghId);
        });
    };

    self.openAddSupplierListDialogToolbar = function () {
        self.openAddSupplierListDialog(null, true)
    };

    function revertDeletion() {
        angular.forEach(self.previousDeleted, function (item) {
            self.pushItem(item);
        })
    }

    self.warnAndRedirectToConversations = function (event, isSupport) {
        if ($scope.dialogData.$dirty) {
            if (canSave()) {
                RedirectAndSaveService.showRedirectAndSaveDialog(self.saveAndRedirectToConversations,
                    isSupport ? self.redirectToNewSupport : self.redirectToConversations, event,
                    self.trns.changedDataQuestion, TranslationService.get("save"), TranslationService.get("abort"), self.trns.noSave,
                    false);
            }
            else if (canChangeDates()) {
                RedirectAndSaveService.showRedirectAndSaveDialog(self.saveDatesAndRedirectToConversations,
                    isSupport ? self.redirectToNewSupport : self.redirectToConversations, event,
                    self.trns.changedDataQuestion, TranslationService.get("save"), TranslationService.get("abort"), self.trns.noSave,
                    false);
            }
            else {
                if (isSupport) {
                    self.redirectToNewSupport();
                }
                else {
                    self.redirectToConversations();
                }
            }
        }
        else {
            if (isSupport) {
                self.redirectToNewSupport();
            }
            else {
                self.redirectToConversations();
            }
        }
    };

    self.warnAndRedirectToNewConversation = function (event) {
        if ($scope.dialogData.$dirty) {
            if (canSave()) {
                RedirectAndSaveService.showRedirectAndSaveDialog(self.saveAndRedirectToNewConversation,
                    self.redirectToNewConversation, event, self.trns.changedDataQuestion, TranslationService.get("save"),
                    TranslationService.get("abort"), self.trns.noSave, false);
            }
            else if (canChangeDates()) {
                RedirectAndSaveService.showRedirectAndSaveDialog(self.saveDatesAndRedirectToNewConversation,
                    self.redirectToNewConversation, event, self.trns.changedDataQuestion, TranslationService.get("save"),
                    TranslationService.get("abort"), self.trns.noSave, false);
            }
            else {
                self.redirectToNewConversation();
            }
        }
        else {
            self.redirectToNewConversation();
        }
    };

    self.saveAndRedirectToConversations = function () {
        RFXBuyerService.saveAndRedirectToConversations(self);
    };

    self.saveAndRedirectToNewConversation = function () {
        RFXBuyerService.saveAndRedirectToNewConversation(self);
    };

    self.saveDatesAndRedirectToNewConversation = function () {
        RFXBuyerService.saveDatesAndRedirectToNewConversation(self);
    };

    self.saveDatesAndRedirectToConversations = function () {
        RFXBuyerService.saveDatesAndRedirectToConversations(self);
    };

    self.redirectToConversations = function() {
        $redirect.redirectTo(null, 'rfxthread/buyer/' + self.id);
    };

    self.redirectToNewSupport = function() {
        $redirect.redirectTo(null, 'rfxthread/edit/buyer/0/' + self.id + '/true');
    };

    self.redirectToNewConversation = function() {
        $redirect.redirectTo(null, 'rfxthread/edit/buyer/0/' + self.id + '/false');
    };

    self.allowConversations = function () {
        return impactX.isDefined(self, 'data.allowConversations');
    };

    self.openEditDateDialog = function (event) {
        $mdDialog.show({
            templateUrl: "modules/rfx/templates/rfx-edit-date-dialog.html",
            controller: "RFXEditDateCtrl",
            controllerAs: "rfxEditDateCtrl",
            targetEvent: event,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
                rfqhId: self.id,
                reload: false
            }
        });
    };

    self.openAddSupplierDialog = function (event) {
        $mdDialog.show({
            templateUrl: "modules/rfx/templates/rfx-add-supplier-dialog.html",
            controller: "RFXAddSupplierCtrl",
            controllerAs: "rfxAddSupplierCtrl",
            targetEvent: event,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
                rfqhId: self.id
            }
        });
    };

    self.addComparisonOffer = function () {
        RFXBuyerService.addComparisonOffer(self.id);
    };

    self.normalizeWeights = function () {
        if (self.data.items && self.data.items.length > 0) {
            // total is 100% with 3 decimals allowed => integer is 100000
            // divide by number of items and truncate any decimals
            var size = self.data.items.length;
            var decimalFactor = 1000;
            var total = 100 * decimalFactor;
            var normalized = Math.floor(total / size);
            var highestWeightItem;
            var highestWeight = 0
            for (var i = 0; i < size; i++) {
                var item = self.data.items[i];
                if (!highestWeightItem || highestWeight < item.weightValuePartPublic.value) {
                    highestWeightItem = item;
                    highestWeight = item.weightValuePartPublic.value;
                }
                item.weightValuePartPublic.value = normalized / decimalFactor;
            }
            highestWeightItem.weightValuePartPublic.value = (normalized + (total - (normalized * size))) / decimalFactor;
            self.checkWeights(false, self.data.items);
        }
    }

    self.checkWeights = function (changed, items) {
        if (self.data.allowPositionWeighting)
        {
            if (items && items.length > 1)
            {
                var total = 0;
                for (var i = 0; i < items.length; i++)
                {
                    total += Number(items[i].weightValuePartPublic.value);
                }
                self.weightingTotal = total;
                $scope.dialogData['weighting'].$setValidity("invalidFactors", total === 100);
                self.changedWeight = changed;
            }
            else
            {
                self.weightingTotal = 0;
                $scope.dialogData['weighting'].$setValidity("invalidFactors", true);
            }
        }
    }

    self.decideEarly = function () {
        return RFXBuyerService.decideEarly(self.id).then(function () {
            self.decide();
        });
    };

    self.checkCanSend = function () {
        self.sendErrorList.length = 0;
        let description = impactX.isDefined(self, "data.description.value");
        if (!description || description.length <= 0) {
            let items = impactX.isDefined(self, "data.items");
            if (!items || items.length <= 0) {
                self.sendErrorList.push(self.trns.noItemsError);
            }
            else {
                let foundNonInternal = false;
                for (let i = 0; i < self.data.items.length; i++) {
                    if (!self.data.items[i].isInternal) {
                        foundNonInternal = true;
                        break;
                    }
                }
                if (!foundNonInternal) {
                    self.sendErrorList.push(self.trns.noItemsError);
                }
            }
        }
        let suppliers = impactX.isDefined(self, "data.suppliers.length");
        let minNumSuppliers = impactX.isDefined(self, "data.minNumOfSuppliers");
        let maxNumSuppliers = impactX.isDefined(self, "data.maxNumOfSuppliers");
        if (!suppliers) {
            self.sendErrorList.push(self.trns.minNumSuppliersError);
        }
        else
        {
            if (suppliers < minNumSuppliers) {
                self.sendErrorList.push(self.trns.minNumSuppliersError);
            }
            if (maxNumSuppliers && maxNumSuppliers > 0 && suppliers > maxNumSuppliers) {
                self.sendErrorList.push(self.trns.maxNumSuppliersError);
            }

            let foundNotAllowedSupplier = false;
            angular.forEach(self.data.suppliers, function (supplier) {
                if (!foundNotAllowedSupplier && supplier.noOrderAllowed) {
                    self.sendErrorList.push(self.trns.notAuthorizedForAllSuppliers);
                    foundNotAllowedSupplier = true;
                }
            });
        }
    };

    self.canRequestSupport = function () {
        return self.data && !self.data.requestedSupport;
    }

    self.requestSupport = function (event) {
        RFXBuyerService.saveData({}, self).then(function () {
            $mdDialog.show({
                templateUrl: "modules/rfx/templates/rfx-requestSupport-details.html",
                controller: "RfxRequestSupportDetailsCtrl",
                controllerAs: "ctrl",
                targetEvent: event,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                locals: {
                    rfqhId: self.id,
                }
            }).then(function () {
                $route.reload();
            });
        });
    };

    self.getCascadeTimelineCSS = function(index) {
        if(self.data.cascadeTimeline.entries.length === 1) {
            return 'table-timeline-line-single';
        }
        else if(index === 0) {
            return 'table-timeline-line-first';
        }
        else if(index === self.data.cascadeTimeline.entries.length - 1) {
            return 'table-timeline-line-last';
        }
        else {
            return 'table-timeline-line';
        }
    }

    self.redirectToOffer = function (rfqsId) {
        $redirect.redirectTo(null, '/rfx/offer/' + rfqsId);
    }


    $scope.$watch(function () {
        return self.data && self.data.items && self.data.items.length;
    }, function (newValue, oldValue) {
        if (newValue !== oldValue) {
            self.checkCanSend();
        }
    });

    $scope.$watch(function () {
        return self.data && self.data.suppliers && self.data.suppliers.length;
    }, function (newValue, oldValue) {
        if (newValue !== oldValue) {
            self.checkCanSend();
        }
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get("back"),
                action: self.back,
                type: 'dialogaction'
            },
            {
                label: self.trns.save,
                action: self.saveData,
                type: 'dialogaction',
                condition: canSave
            },
            {
                label: self.trns.saveRequestAndBack,
                action: self.saveDataAndBack,
                type: 'dialogaction',
                condition: canSave
            },
            {
                label: self.trns.edit,
                action: self.editPosition,
                type: 'dialogaction',
                condition: canEditPosition
            },
            {
                label: self.trns.delete,
                action: self.deletePositions,
                type: 'dialogaction',
                condition: canDeletePositions
            },
            {
                label: self.trns.conversations,
                action: self.warnAndRedirectToConversations,
                type: 'dialogaction',
                condition: canViewConversations
            },
            {
                label: self.trns.saveDates,
                action: self.saveDates,
                type: 'validation',
                condition: canChangeDates,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: self.trns.changeDates,
                action: self.openEditDateDialog,
                type: 'dialogaction',
                condition: canOpenDatesDialog,
            },
            {
                label: self.trns.addSupplierAfterSend,
                action: self.openAddSupplierListDialogToolbar,
                type: 'dialogaction',
                condition: canAddSuppliersAfterSend,
            },
            {
                label: self.trns.addComparisonOffer,
                action: self.addComparisonOffer,
                type: 'dialogaction',
                condition: canAddComparisonOffer,
                process: 'RFXAddComparisonOffer'
            },
            {
                label: self.trns.decide,
                action: self.decide,
                type: 'validation',
                condition: canDecide,
                params: {
                    form: $scope.dialogData,
                    disableExpression: {
                        valueFunction: disableDecide,
                        error: self.trns.decisionNotAllowedUntil
                    }
                }
            },
            {
                label: self.trns.decide,
                action: self.decideEarly,
                type: 'dialogaction',
                condition: allowEarlyDecision
            },
            {
                label: self.trns.newRound,
                action: self.newRound,
                condition: canInitNewRound
            },
            {
                label: self.trns.reworkBeforeSend,
                action: self.reworkBeforeSend,
                type: 'dialogaction',
                condition: canReworkBeforeSend
            },
            {
                label: self.trns.cancel,
                action: self.cancel,
                condition: canCancel,
                process: "RFXEdit"
            },
            {
                label: self.trns.rework,
                action: self.rework,
                condition: canCancel,
                process: "RFXEdit"
            },
            {
                label: self.trns.offers,
                linkFunction: getOfferLink,
                type: 'link',
                condition: canViewOffers,
                process: 'RFXView'
            },
            {
                label: self.trns.openOffers,
                type: 'dialogaction',
                action: openOffers,
                condition: canOpenOffers
            },
            {
                label: self.trns.comparisonOffers,
                linkFunction: getComparisonOfferLink,
                type: 'link',
                condition: hasComparisonOffers,
                process: 'RFXAddComparisonOffer'
            },
            {
                label: self.trns.delete,
                type: 'dialogaction',
                action: deleteRFQH,
                condition: canDeleteRFQH
            },
            {
                label: self.trns.downloadAwardAct,
                type: 'dialogaction',
                action: downloadAwardAct,
                condition: canDownloadAwardAct
            }
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons(buttonDefinition);
    }

    function canViewConversations() {
        return self.allowConversations();
    }

    function canPublish() {
        return self.data.canPublish;
    }

    function canDecide() {
        return self.data.showDecide && !allowEarlyDecision();
    }

    function disableDecide() {
        return !self.data.canDecide;
    }

    function canCancel() {
        return self.data.canCancel;
    }

    function canSave() {
        return !self.data.readOnlyDialog;
    }

    function canEditPosition() {
        return self.selectedPositions.length === 1;
    }

    function canDeletePositions() {
        return self.selectedPositions.length >= 1;
    }

    function getOfferLink() {
        return "rfx/offers/" + self.id;
    }

    function canViewOffers() {
        return self.data.canViewOffers;
    }

    function canChangeDates() {
        return !canSave() && self.data.canChangeDates && !self.data.isPublished;
    }

    function canChangeUsers() {
        return !canSave() && self.data.canChangeUsers;
    }

    function canReworkBeforeSend() {
        return !canSave() && self.data.canReworkBeforeSend && !self.data.isPublished;
    }

    function canOpenDatesDialog() {
        return !canSave() && self.data.canChangeDates && self.data.isPublished &&
            (!self.data.hasCascade || self.data.cascadeOnFirstSupplier);
    }

    function canAddSuppliersAfterSend() {
        return !canSave() && self.data.canAddSuppliersAfterSend && self.data.isPublished;
    }

    function canOpenOffers() {
        return self.data.canOpenOffers;
    }

    function openOffers(event) {
        RFXBuyerService.openOffers(event, self.id);
    }

    function canInitNewRound() {
        return self.data.canInitNewRound;
    }

    function canAddComparisonOffer() {
        return self.data.canAddComparisonOffer;
    }

    function getComparisonOfferLink() {
        return "rfx/comparisonoffers/" + self.id;
    }

    function hasComparisonOffers() {
        return self.data.hasComparisonOffers;
    }

    function allowEarlyDecision() {
        return self.data.showDecide && self.data.allowEarlyDecision;
    }

    function canDeleteRFQH() {
        return self.data && self.data.canDelete;
    }

    function deleteRFQH(event) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {rfqhId: self.id}, "/rfx/buyer/delete").then(function () {
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                $redirect.redirectTo(null, "/rfxbuyerlist");
            });
        }, event, TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    }

    function canDownloadAwardAct() {
        return self.id > 0;
    };

    function downloadAwardAct() {
        DownloadService.openDownloadPost('/rfx/download/awardact', {paramName: "id", paramValue: parseInt(self.id)});
    };

    getData();
}
